export const adminLanguages = [
  'en',
  'nl',
  'el',
  'de',
  'fr',
  'es',
  'it',
  'pt',
  'bg',
  'tr',
  'ru',
  'hi',
  'ja',
];
